import MenuIcon from "@mui/icons-material/Menu";
import { Chip, Container, Link as MaterialLink, Grid2, useTheme } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Toolbar from "@mui/material/Toolbar";
import withStyles from "@mui/styles/withStyles";
import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, Paths } from "../common/navigation";

import Badge from "@mui/material/Badge";
import classnames from "classnames";
import MenuLink from "components/common/MenuLink";
import { SMALL_DEVICE_MEDIA_SIZE } from "components/common/constants";
import { currentUserBlockedPathsSelector } from "components/login/logic/actions";
import { hasAccessToPath } from "components/login/useHasAccessToPath";
import PropTypes from "prop-types";
import { connect, shallowEqual, useSelector } from "react-redux";
import useGetApiImports from "../../hooks/useGetApiImports";
import { assertArray } from "core/validation";
import useMediaQuery from "@mui/material/useMediaQuery";

const styles = (theme) => ({
    appBar: {
        [theme.breakpoints.down(SMALL_DEVICE_MEDIA_SIZE)]: {
            position: "fixed",
            top: 0,
        },
        color: "#fff !important",
        backgroundColor: "#009688 !important",
        boxShadow: "none !important",
        borderBottom: `1px solid ${theme.palette.grey["100"]} !important`,
    },
    inline: {
        display: "inline",
    },
    flex: {
        display: "flex",
        [theme.breakpoints.down("sm")]: {
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
        },
    },
    link: {
        textDecoration: "none",
        color: "inherit",
    },
    tagline: {
        display: "inline-block",
        marginLeft: 10,
        [theme.breakpoints.up("md")]: {
            paddingTop: "0.8em",
        },
    },
    iconContainer: {
        display: "none",
        [theme.breakpoints.down("md")]: {
            display: "block",
        },
    },
    iconButton: {
        float: "left",
    },
    tabContainer: {
        marginLeft: 20,
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
    },
    tabItem: {
        paddingTop: 20,
        paddingBottom: 20,
        minWidth: "auto",
        fontSize: 14,
    },
    indicatorTab: {
        backgroundColor: "white",
    },
    drawerPaper: {
        background: `${theme.palette.primary.main} !important`,
    },
    listItem: {
        color: "white",
        fontWeight: 600,
    },
    toolBar: {
        paddingLeft: 0,
        paddingRight: 0,
    },
    mainLink: {
        color: "rgba(255,255,255,0.75)",
    },
    mainLinkSelected: {
        borderBottom: "2px solid white",
        paddingBottom: 20,
        color: "rgba(255,255,255)",
    },
    subMenuSelected: {
        color: "rgba(255,255,255)",
    },
});
export const MENU_CLOSE_RESPONSIVE_MATCH = '(max-width:957px)';
const Topbar = ({ classes, totalAdvSelected, totalAdvInLogSelected, children }) => {
    const [menuDrawer, setMenuDrawer] = useState(false);
    const location = useLocation();
    // 957 is when the menu got broke dont remove it
    const isSmallDevice = useMediaQuery(MENU_CLOSE_RESPONSIVE_MATCH);
    const paths = useSelector(currentUserBlockedPathsSelector, shallowEqual);
    const mobileMenuOpen = () => {
        setMenuDrawer(true);
    };

    const mobileMenuClose = () => {
        setMenuDrawer(false);
    };
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const isPathSelected = useCallback(
        (path) => {
            const currentPath = location.pathname;
            if (!path.pathname && path.submenu) {
                const filter = path.submenu.filter((sm) => currentPath.startsWith(sm.pathname));
                return filter.length > 0;
            }
            if (assertArray(path.pathnames)) {
                const filter = path.pathnames.filter(sm => currentPath.startsWith(sm));
                return filter.length > 0;
            }
            return currentPath.startsWith(path.pathname);
        },
        [location.pathname]
    );

    const { filmsNoAccepted } = useGetApiImports();

    return (
        (<AppBar position="fixed" color="primary" className={classes.appBar}>
            <Toolbar className={classes.toolBar}>
                <Container maxWidth={"xl"}>
                    <Grid2 container alignItems="baseline">
                        <Grid2
                            size={{
                                xs: 6,
                                xl: 10,
                                lg: 10,
                                sm: 6,
                                md: 8
                            }}>

                            <div className={classes.tabContainer}>
                                {isSmallDevice ? (
                                    <>
                                        <div >
                                            <IconButton onClick={mobileMenuOpen} color="inherit" aria-label="Menu">
                                                <MenuIcon />
                                            </IconButton>
                                        </div>
                                        <SwipeableDrawer
                                            anchor="left"
                                            open={menuDrawer}
                                            classes={{ paper: classes.drawerPaper }}
                                            onClose={mobileMenuClose}
                                            onOpen={mobileMenuOpen}
                                        >
                                            <AppBar title="Menu" />
                                            <List>
                                                {Menu.map((item) => {
                                                    const hasAccess = () => {
                                                        if (item.pathname) {
                                                            return hasAccessToPath(item.pathname, paths);
                                                        }
                                                        else return item.submenu.some(subm => hasAccessToPath(subm.pathname, paths));
                                                    }
                                                    return hasAccess() && (
                                                        <DrawerLink
                                                            item={item}
                                                            key={item.label}
                                                            classes={classes}
                                                            filmsNoAccepted={filmsNoAccepted}
                                                            totalAdvSelected={totalAdvSelected}
                                                            totalAdvInLogSelected={totalAdvInLogSelected}
                                                            search={location.search}
                                                        />
                                                    );
                                                })}
                                            </List>
                                        </SwipeableDrawer>
                                    </>
                                ) : (
                                    <>
                                        {Menu.map((path) => {
                                            const hasAccess = () => {
                                                if (path.pathname) {
                                                    return hasAccessToPath(path.pathname, paths);
                                                }
                                                else return path.submenu.some(subm => hasAccessToPath(subm.pathname, paths));
                                            }
                                            return hasAccess() && (
                                                <ToolbarLink
                                                    classes={classes}
                                                    menu={path}
                                                    key={path.label}
                                                    filmsNoAccepted={filmsNoAccepted}
                                                    totalAdvSelected={totalAdvSelected}
                                                    totalAdvInLogSelected={totalAdvInLogSelected}
                                                    isMenuSelected={isPathSelected}
                                                />
                                            )
                                        })}
                                    </>
                                )}

                            </div>
                            {isSmallDevice && (
                                <React.Fragment>


                                </React.Fragment>
                            )}
                        </Grid2>
                        <Grid2
                            style={{ textAlign: "right" }}
                            size={{
                                xl: 2,
                                lg: 2,
                                xs: 6,
                                sm: 6,
                                md: 4
                            }}>
                            {children}
                        </Grid2>
                    </Grid2>
                </Container>
            </Toolbar>
        </AppBar>)
    );
};

Topbar.propTypes = {
    classes: PropTypes.object.isRequired,
    location: PropTypes.object,
    children: PropTypes.node,
    noTabs: PropTypes.bool,
    totalAdvSelected: PropTypes.number,
    totalAdvInLogSelected: PropTypes.number,
};

export function DrawerLink({ item, search, totalAdvSelected, classes, totalAdvInLogSelected, filmsNoAccepted }) {
    const isReport = item.label === "Reports";
    const isAdmin = item.label === "Admin";
    const paths = useSelector(currentUserBlockedPathsSelector, shallowEqual);

    if (item.pathname === null) {
        const items = [];
        item.submenu.map((it) => {
            const { external, pathname, label } = it;
            let _label = label;

            if (isReport) {
                if (totalAdvSelected && pathname === Paths.ADV_REPORT) {
                    _label = (
                        <span>
                            {label} <Chip label={totalAdvSelected} color="secondary" size="small" />
                        </span>
                    );
                }
                if (totalAdvInLogSelected && pathname === Paths.LOG_REPORT) {
                    _label = (
                        <span>
                            {label} <Chip label={totalAdvInLogSelected} color="secondary" size="small" />
                        </span>
                    );
                }
            } else if (isAdmin) {
                if (filmsNoAccepted && pathname === Paths.ADMIN_API_IMPORT) {
                    _label = (
                        <span>
                            {label} <Chip label={filmsNoAccepted} color="secondary" size="small" />
                        </span>
                    );
                }
            }
            if (hasAccessToPath(pathname, paths)) {
                items.push(
                    <ListItem
                        component={external ? MaterialLink : Link}
                        href={external ? pathname : null}
                        to={external ? null : { pathname }}
                        classes={{ root: classes.listItem }}
                        key={label}
                    >
                        <ListItemText primary={_label} />
                    </ListItem>
                );
            }
        });
        return items;
    }
    const { external, pathname, label } = item;

    return (
        <ListItem
            component={external ? MaterialLink : Link}
            href={external ? pathname : null}
            to={external ? null : { pathname, search }}
            classes={{ root: classes.listItem }}
            key={label}
        >
            <ListItemText primary={label} />
        </ListItem>
    );
}

DrawerLink.propTypes = {
    classes: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    search: PropTypes.string,
    totalAdvSelected: PropTypes.number,
    totalAdvInLogSelected: PropTypes.number,
    filmsNoAccepted: PropTypes.number,
};

export function ToolbarLink({
    menu,
    classes,
    isMenuSelected,
    filmsNoAccepted,
    totalAdvSelected,
    totalAdvInLogSelected,
}) {
    const selected = isMenuSelected(menu);
    const isReport = menu.label === "Reports";
    const isAdmin = menu.label === "Admin";
    const paths = useSelector(currentUserBlockedPathsSelector, shallowEqual);

    const hasAdv = (isReport && (totalAdvSelected > 0 || totalAdvInLogSelected > 0)) || (isAdmin && filmsNoAccepted);
    function onRenderItem(menuItem) {
        const _selected = isMenuSelected(menuItem);
        let label = menuItem.label;
        if (isReport) {
            if (totalAdvSelected && menuItem.pathname === Paths.ADV_REPORT) {
                label = (
                    <span>
                        {menuItem.label} <Chip label={totalAdvSelected} color="secondary" size="small" />
                    </span>
                );
            }
            if (totalAdvInLogSelected && menuItem.pathname === Paths.LOG_REPORT) {
                label = (
                    <span>
                        {menuItem.label} <Chip label={totalAdvInLogSelected} color="secondary" size="small" />
                    </span>
                );
            }
        } else if (isAdmin) {
            if (filmsNoAccepted && menuItem.pathname === Paths.ADMIN_API_IMPORT) {
                label = (
                    <span>
                        {menuItem.label} <Chip label={filmsNoAccepted} color="secondary" size="small" />
                    </span>
                );
            }
        }
        return (
            <Link
                color="inherit"
                key={menuItem.pathname}
                variant="body2"
                to={menuItem.pathname}
                className={classnames("toolbarSubLink", classes.mainLink, _selected ? classes.subMenuSelected : "")}
            >
                {label}
            </Link>
        );
    }
    const link = (
        <Link
            color="inherit"
            key={menu.pathname || ""}
            variant="body2"
            to={menu.pathname || ""}
            className={classnames("toolbarLink", classes.mainLink, selected ? classes.mainLinkSelected : "")}
        >
            {menu.label}
        </Link>
    );
    if (menu.pathname === null) {
        const menuRender = (
            <label className={classnames("toolbarLink", classes.mainLink, selected ? classes.mainLinkSelected : "")}>
                {hasAdv ? (
                    <Badge color="secondary" variant="dot">
                        <span>{menu.label}</span>
                    </Badge>
                ) : (
                    menu.label
                )}
            </label>
        );
        const subMenu = menu.submenu.filter((sub) => hasAccessToPath(sub.pathname, paths));
        return <MenuLink menu={menuRender} menus={subMenu} onRenderItem={onRenderItem} />;
    }
    return link;
}

ToolbarLink.propTypes = {
    classes: PropTypes.object.isRequired,
    menu: PropTypes.object.isRequired,
    selected: PropTypes.func,
    isMenuSelected: PropTypes.func.isRequired,
    filmsNoAccepted: PropTypes.number,
    totalAdvSelected: PropTypes.number,
    totalAdvInLogSelected: PropTypes.number,
};

export default connect((state) => ({
    totalAdvSelected: state.reportAdv.advertisersCount,
    totalAdvInLogSelected: state.reportLog.advertisersCount,
    filmsNoAccepted: state.apiImport.filmsNoAccepted,
}))(withStyles(styles)(Topbar));
